/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { useCallback, useState } from 'react';

/* Import libraries */
/* Import types */
import type { LocalizedMessage } from '@/types/i18n';

type Translate = (key: string, values?: Record<string, number | string>) => string;

export function useAppModals(t: Translate) {
    const [statusModalOpen, setStatusModalOpen] = useState(false);
    const [statusModalTitle, setStatusModalTitle] = useState<LocalizedMessage>({ key: 'Status' });
    const [statusModalMessage, setStatusModalMessage] = useState<LocalizedMessage>({ key: '' });

    const closeStatusModal = useCallback(() => {
        setStatusModalOpen(false);
    }, []);
    const showStatusModal = useCallback((title: LocalizedMessage, message: LocalizedMessage) => {
        setStatusModalTitle(title);
        setStatusModalMessage(message);
        setStatusModalOpen(true);
    }, []);

    return {
        statusModal: {
            close: closeStatusModal,
            isOpen: statusModalOpen,
            message: t(statusModalMessage.key, statusModalMessage.values),
            show: showStatusModal,
            title: t(statusModalTitle.key, statusModalTitle.values),
        },
    };
}
